var _rect, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyImageSquare(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.805359,
    y: 0.805359,
    width: 78.3893,
    height: 78.3893,
    rx: 10.4697,
    fill: "white",
    stroke: "#EEF0F2",
    strokeWidth: 1.61072
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1543 37.5C44.8774 37.5 45.5843 37.2801 46.1856 36.868C46.7869 36.456 47.2555 35.8703 47.5322 35.1851C47.809 34.4998 47.8814 33.7458 47.7403 33.0184C47.5992 32.291 47.251 31.6228 46.7397 31.0984C46.2283 30.5739 45.5768 30.2168 44.8676 30.0721C44.1584 29.9274 43.4232 30.0016 42.7551 30.2855C42.087 30.5693 41.516 31.0499 41.1142 31.6666C40.7125 32.2833 40.498 33.0083 40.498 33.75C40.498 34.7446 40.8833 35.6984 41.5689 36.4017C42.2546 37.1049 43.1846 37.5 44.1543 37.5ZM44.1543 32.5C44.3953 32.5 44.631 32.5733 44.8314 32.7107C45.0318 32.848 45.188 33.0432 45.2803 33.2716C45.3725 33.5001 45.3967 33.7514 45.3496 33.9939C45.3026 34.2363 45.1865 34.4591 45.0161 34.6339C44.8456 34.8087 44.6285 34.9278 44.3921 34.976C44.1556 35.0242 43.9106 34.9995 43.6879 34.9049C43.4652 34.8102 43.2749 34.65 43.1409 34.4445C43.007 34.2389 42.9355 33.9972 42.9355 33.75C42.9355 33.4185 43.0639 33.1005 43.2925 32.8661C43.5211 32.6317 43.8311 32.5 44.1543 32.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6885 25H28.3135C27.667 25 27.047 25.2634 26.5899 25.7322C26.1328 26.2011 25.876 26.837 25.876 27.5V52.5C25.876 53.163 26.1328 53.7989 26.5899 54.2678C27.047 54.7366 27.667 55 28.3135 55H52.6885C53.3349 55 53.9549 54.7366 54.4121 54.2678C54.8692 53.7989 55.126 53.163 55.126 52.5V27.5C55.126 26.837 54.8692 26.2011 54.4121 25.7322C53.9549 25.2634 53.3349 25 52.6885 25ZM52.6885 52.5H28.3135V45L34.4072 38.75L41.22 45.7375C41.6767 46.2031 42.2945 46.4645 42.9385 46.4645C43.5824 46.4645 44.2002 46.2031 44.6569 45.7375L46.5947 43.75L52.6885 50V52.5ZM52.6885 46.4625L48.3132 41.975C47.8565 41.5094 47.2387 41.248 46.5947 41.248C45.9508 41.248 45.333 41.5094 44.8763 41.975L42.9385 43.9625L36.1257 36.975C35.669 36.5094 35.0512 36.248 34.4072 36.248C33.7633 36.248 33.1455 36.5094 32.6888 36.975L28.3135 41.4625V27.5H52.6885V46.4625Z",
    fill: "black"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImageSquare);
export default __webpack_public_path__ + "static/media/empty-image-square.f99f761648462c0703e6166b45e41391.svg";
export { ForwardRef as ReactComponent };